import React, { useState, useEffect } from 'react';
import { mui } from '~/tools/mui';
import { icons } from '~/tools/icons';
import { jss } from '~/tools/jss';
import { propTypes } from '~/tools/prop_types';
import * as languages from '~/behaviors/languages';
import { statuses } from '~/config/settings/notification.settings';
import Button from '~/components/Button';

const useStyles = jss.makeStyles((theme) => ({
  container: {
    backgroundColor: '#fff',
  },
  contentContainer: {
    minWidth: 450,
    maxWidth: 600,
    display: 'flex',
  },
  iconContainer: {
    width: 60,
    height: 60,
    marginRight: '1.5rem',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '0.5rem',
  },
  content: {
    fontSize: '1rem',
    whiteSpace: 'pre-wrap',
    fontFamily: theme.typography.fontFamily,
  },
  actions: {
    padding: '1.5rem',
  },
  icon: {
    fontSize: 60,
  },
  info: {
    // @ts-expect-error TS(2339): Property 'legacyPalette' does not exist on type 'T... Remove this comment to see the full error message
    color: theme.legacyPalette.blue,
  },
  error: {
    // @ts-expect-error TS(2339): Property 'legacyPalette' does not exist on type 'T... Remove this comment to see the full error message
    color: theme.legacyPalette.red,
  },
  success: {
    // @ts-expect-error TS(2339): Property 'legacyPalette' does not exist on type 'T... Remove this comment to see the full error message
    color: theme.legacyPalette.green,
  },
  warning: {
    // @ts-expect-error TS(2339): Property 'legacyPalette' does not exist on type 'T... Remove this comment to see the full error message
    color: theme.legacyPalette.neutral,
  },
}));

const StatusDialog = ({
  open = false,
  title = '',
  status = statuses.info,
  onClose = () => {},
  closeButtonLabel = languages.t('button.ok'),
  minContentWidth = 0,
  children,
  showCancel = false,
  cancelButtonLabel = languages.t('button.cancel'),
  onCancel = () => {},
}) => {
  // @ts-expect-error TS(2339): Property 'propTypes' does not exist on type '({ op... Remove this comment to see the full error message
  StatusDialog.propTypes = {
    open: propTypes.bool,
    title: propTypes.string,
    message: propTypes.string,
    status: propTypes.oneOf(Object.values(statuses)),
    showCancel: propTypes.bool,
    onClose: propTypes.func,
    closeButtonLabel: propTypes.string,
    cancelButtonLabel: propTypes.string,
    onCancel: propTypes.func,
    minContentWidth: propTypes.number,
  };

  // ------------------------------------------------------------------ State --
  const styles = useStyles();

  // @ts-expect-error TS(2345): Argument of type '(props: SvgIconProps) => Element... Remove this comment to see the full error message
  const [StatusIcon, setStatusIcon] = useState(icons.Info);
  const [statusStyles, setStatusStyles] = useState(styles.info);

  // -------------------------------------------------------------- Lifecycle --
  useEffect(() => {
    switch (status) {
      case statuses.error:
        setStatusIcon(icons.Error);
        setStatusStyles(styles.error);
        break;
      case statuses.warning:
        setStatusIcon(icons.Warning);
        setStatusStyles(styles.warning);
        break;
      case statuses.success:
        setStatusIcon(icons.CheckCircle);
        setStatusStyles(styles.success);
        break;
      case statuses.info:
      default:
        setStatusIcon(icons.Info);
        setStatusStyles(styles.info);
    }
    // eslint-disable-next-line
  }, [status]);

  // ----------------------------------------------------------------- Events --
  const handleClickClose = (e) => {
    e.preventDefault();

    onClose();
  };

  const handleClickCancel = (e) => {
    e.preventDefault();

    onCancel();
  };

  // -------------------------------------------------------------- Interface --
  return (
    <mui.Dialog
      open={open}
      onClose={showCancel ? handleClickCancel : handleClickClose}
      PaperProps={{
        className: styles.container,
        style: { minWidth: minContentWidth },
      }}
    >
      <mui.DialogContent className={styles.contentContainer}>
        <div className={styles.iconContainer}>
          {/*
            // @ts-expect-error TS(2604): JSX element type 'StatusIcon' does not have any co... Remove this comment to see the full error message */}
          <StatusIcon className={jss.combineStyles(styles.icon, statusStyles)} />
        </div>

        <div>
          {title && (
            <mui.Typography variant="h2" className={styles.title}>
              {title}
            </mui.Typography>
          )}

          <div className={styles.content}>{children}</div>
        </div>
      </mui.DialogContent>

      <mui.DialogActions className={styles.actions}>
        {showCancel && (
          <Button onClick={handleClickCancel} data-testid="dialog-cancel-button" color="primary" variant="text">
            {cancelButtonLabel}
          </Button>
        )}
        <Button onClick={handleClickClose} color="primary" variant="contained" data-testid="dialog-close-button">
          {closeButtonLabel}
        </Button>
      </mui.DialogActions>
    </mui.Dialog>
  );
};

export default StatusDialog;
